import { axiosInstance } from '../shared/services/axios-instance'
import * as endpoints from '../constants/api-constants'

class ForumServices {
  static getFormuPage(forumId, page, size, orderByLikes, config) {
    return axiosInstance
      .get(
        endpoints.getRepliesByForum +
          `?forumId=${forumId}&page=${page}&size=${size}&filterByLikes=${orderByLikes}`,
        config
      )
      .then(resp => resp.data)
  }
  static saveFormuComment(forumId, commentContent, config) {
    const data = {
      comment: commentContent,
      forumId: forumId,
    }
    return axiosInstance
      .post(endpoints.replyForum, data, config)
      .then(resp => resp.data)
  }
  static saveLikeByCommentId(id, like, config) {
    return axiosInstance
      .post(
        endpoints.saveLikeByCommentId + `?comentarioId=${id}&isLike=${like}`,
        {},
        config
      )
      .then(resp => resp.data)
  }
  static getForumByConcourseId(id) {
    return axiosInstance
      .get(endpoints.getForumsByConcourse + `?concourseId=${id}`)
      .then(resp => resp.data)
  }
}

export default ForumServices
